// Modules
import React from 'react';

// Components
import MvCheckBox from 'Generic/MvCheckBox';
import ToolTip from 'Generic/ToolTip';

// Interfaces
import { Tip } from 'Interfaces/TipInterface';

// Styles
import "./BorrowToUsePoints.sass";

// @ts-ignore
import { LocalizationContext } from "react-localize";

type BorrowToUsePointsState = {
  checked: boolean;
};

type Props = {
  usageId: string;
  checked: boolean;
  disabled?: boolean;
  onCheck(checked: boolean, usageId: string): void;
};

class BorrowToUsePoints extends React.Component<Props,BorrowToUsePointsState> {
  render() {
    const { localize } = this.context;
    const headerText = `${localize("static.content.ayp-ways-to-apply")}`;
    const tooltip: [Tip] = [{ label: "", desc: `${localize("static.content.ayp-tooltip-borrow-to-use-pts")}` }];
    const phrase = localize("static.content.ayp-borrow-to-use-pts");
    const firstWord = phrase.split(" ")[0];
    const {checked, onCheck, usageId, disabled} = this.props;

    // Borrow - extract the first word from the phrase - which hopefully will be "Borrow"
    // and style it like a hyperlink and give it a tooltip
    const styledFirstWord =
      <ToolTip useRefToPosition={false} tabIndex={-1} tip={tooltip} id={`borrow-to-use-${usageId}`}>
        <span className="borrow-first-word">{firstWord}</span>
      </ToolTip>

    return (
      <div aria-label={phrase} className="borrow-to-use-points">
        <span aria-label={headerText} className="header-text bold">
          {headerText}{":"}
        </span>
        <div className="borrow-check-box">
          <MvCheckBox
            label=""
            id={usageId}
            checked={checked}
            disabled={disabled}
            onChange={(e) => onCheck(!checked, usageId)} />
        </div>
        <div className="borrow-phrase">
          {styledFirstWord}
          {phrase.replace(firstWord, " ")}
        </div>
      </div>
    );
  }
}

BorrowToUsePoints.contextType = LocalizationContext;
export default BorrowToUsePoints;
